import React from 'react'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { updateNewCustomerDiscountExpiresAtUserAction } from 'modules/training/modules/training-users/actions/updateNewCustomerDiscountExpiresAt/index.js'
import {
  addHoursDateUtil,
  createISOStrDateUtil
} from 'packages/src'
import { getNewCustomerDiscountExpiresAtUserSelect } from 'modules/training/modules/training-users/selectors/getNewCustomerDiscountExpiresAt/index.js'
import { Countdown } from 'components/Countdown/index.js'
import { View } from 'components/View.js'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'

const DISCOUNT_EXPIRY_IN_HOURS = 24

const ANALYTIC_EVENT = {
  SHOW_NEW_CUSTOMER_DISCOUNT: 'SHOW_NEW_CUSTOMER_DISCOUNT'
}

/**
 * @param isCompact
 * @returns {JSX.Element}
 * @constructor
 */
export function NewCustomerDiscountTimerContent ({ isCompact }) {
  const newCustomerDiscountExpiresAt = useSelector(getNewCustomerDiscountExpiresAtUserSelect)
  const dispatch = useDispatch()

  const handleMount = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.SHOW_NEW_CUSTOMER_DISCOUNT)

    if (newCustomerDiscountExpiresAt) {
      return
    }

    dispatch(
      updateNewCustomerDiscountExpiresAtUserAction(
        createISOStrDateUtil(
          addHoursDateUtil(new Date(), DISCOUNT_EXPIRY_IN_HOURS)
        )
      )
    )
  }

  React.useEffect(() => {
    handleMount()
  }, [])

  if (!newCustomerDiscountExpiresAt) {
    return <></>
  }

  return (
    <View
      mt={isCompact ? 1.5 : 0}
      mb={isCompact ? 0 : -2}
    >
      <View>
        <View mt>
          <Countdown
            end={new Date(newCustomerDiscountExpiresAt)}
          />
        </View>
      </View>
    </View>
  )
}
